var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecInterviewed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79176 1.66699C5.36706 1.66699 5.83343 2.13336 5.83343 2.70866V3.75033H6.8751C7.4504 3.75033 7.91677 4.2167 7.91677 4.792C7.91677 5.3673 7.4504 5.83367 6.8751 5.83367H5.83343V6.87534C5.83343 7.45064 5.36706 7.91701 4.79176 7.91701C4.21646 7.91701 3.75009 7.45064 3.75009 6.87534V5.83367H2.70842C2.13312 5.83367 1.66675 5.3673 1.66675 4.792C1.66675 4.2167 2.13312 3.75033 2.70842 3.75033H3.75009V2.70866C3.75009 2.13336 4.21646 1.66699 4.79176 1.66699ZM4.79176 12.0837C5.36706 12.0837 5.83343 12.5501 5.83343 13.1254V14.167H6.8751C7.4504 14.167 7.91677 14.6334 7.91677 15.2087C7.91677 15.784 7.4504 16.2504 6.8751 16.2504H5.83343V17.292C5.83343 17.8673 5.36706 18.3337 4.79176 18.3337C4.21646 18.3337 3.75009 17.8673 3.75009 17.292V16.2504H2.70842C2.13312 16.2504 1.66675 15.784 1.66675 15.2087C1.66675 14.6334 2.13312 14.167 2.70842 14.167H3.75009V13.1254C3.75009 12.5501 4.21646 12.0837 4.79176 12.0837Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0834 1.66699C12.556 1.66699 12.9694 1.9852 13.0904 2.44211L14.3187 7.08256L17.8123 9.09807C18.1347 9.2841 18.3334 9.62808 18.3334 10.0004C18.3334 10.3726 18.1347 10.7166 17.8123 10.9026L14.3187 12.9181L13.0904 17.5586C12.9694 18.0155 12.556 18.3337 12.0834 18.3337C11.6108 18.3337 11.1974 18.0155 11.0764 17.5586L9.84805 12.9181L6.35455 10.9026C6.03209 10.7166 5.83343 10.3726 5.83343 10.0004C5.83343 9.62808 6.03209 9.28411 6.35455 9.09807L9.84805 7.08256L11.0764 2.44211C11.1974 1.9852 11.6108 1.66699 12.0834 1.66699Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecInterviewed);
export default __webpack_public_path__ + "static/media/rec-interviewed.e372d54f180e629d48d93673a5efc0f3.svg";
export { ForwardRef as ReactComponent };